// expense/ExpenseDefinitionModel.ts

import * as Yup from 'yup'



// Gider Türleri için seçenekler (SelectInput için kullanılacak)
// Bu, kullanıcıya gösterilecek etiketleri içerir.
export const EXPENSE_TYPE_OPTIONS = [
  {value: 'Kira', label: 'Kira'},
  {value: 'Faturalar', label: 'Faturalar'},
  {value: 'Tedarik Malzemeleri', label: 'Tedarik Malzemeleri'},
  {value: 'Seyahat', label: 'Seyahat'},
  {value: 'Maaş', label: 'Maaş'},
  {value: 'Diğer', label: 'Diğer'},
]

// ExpenseDefinitionDTO'ya karşılık gelen React modeli
export interface IExpenseDefinitionModel {
  id: string,  
  expenseType: string // Artık bu alan EXPENSE_TYPES içindeki değerlerden biri olacak
  name: string
}

// Formik başlangıç değerleri
export const initialExpenseDefinition: IExpenseDefinitionModel = {
  id: '',
  expenseType: '', // Varsayılan olarak 'Diğer' seçildi
  name: '',
}

// Yup ile doğrulama şeması
export const validationExpenseDefinition = Yup.object().shape({
  expenseType: Yup.string()
    .required('Gider Türü zorunludur.'),
  name: Yup.string()
    .max(255, 'Gider Adı en fazla 255 karakter olmalıdır.')
    .required('Gider Adı zorunludur.'),
})